import React from 'react';

export type avatarIcon = 'veryBad' | 'bad' | 'average' | 'good' | 'veryGood';

const avatarURL = {
  veryBad: '/static/images/advisor/ai_img_1.svg',
  bad: '/static/images/advisor/ai_img_2.svg',
  average: '/static/images/advisor/ai_img_3.svg',
  good: '/static/images/advisor/ai_img_4.svg',
  veryGood: '/static/images/advisor/ai_img_5.svg',
};

type Props = {
  icon: avatarIcon;
};

const AvatarIcon: React.FC<Props> = props => {
  const iconURL = (() => {
    switch (props.icon) {
      case 'veryBad':
        return avatarURL.veryBad;
      case 'bad':
        return avatarURL.bad;
      case 'average':
        return avatarURL.average;
      case 'good':
        return avatarURL.good;
      case 'veryGood':
        return avatarURL.veryGood;
    }
  })();

  return (
    <div className="icon-advice-avatar-top">
      <img src={iconURL} className="rounded-full" alt="" />
    </div>
  );
};

export default AvatarIcon;
